
import { useLayoutEffect, useState } from 'react';
import debounce from 'lodash/debounce';

const useInterfaceScaling = () => {
  const [scale, setScale] = useState(1);

  useLayoutEffect(() => {
    const updateScale = () => {
      setScale(getScaleByHeight(window.innerHeight));
    };
    window.addEventListener('resize', debounce(updateScale, 100));
    updateScale();
    return () => window.removeEventListener('resize', updateScale);
  }, []);

  return scale;
};

const getScaleByHeight = (height) => {
  const upperBreakpoint = 760;
  const lowerBreakpoint = 540;
  const maxScale = 1;
  const minScale = 0.75;
  if (height >= upperBreakpoint) { 
    // Default scale
    return maxScale;
  }

  if (height <= lowerBreakpoint) { 
    // Minimal scale
    return minScale;
  }

  // Calculate in-between scale
  const diffFromLow = height - lowerBreakpoint;
  const valueRange = upperBreakpoint - lowerBreakpoint;
  const percent = diffFromLow / valueRange;
  const scale = Math.min(maxScale, minScale + roundScale((maxScale - minScale) * percent))
  return scale;
}

function roundScale(num) {
  return Math.floor(num / 0.05) * 0.05;
}

export default useInterfaceScaling;
